/* eslint-disable @typescript-eslint/consistent-type-definitions, id-denylist, @typescript-eslint/no-unused-vars -- generated type definition */

/**
 * DO NOT EDIT!
 * This file was autogenerated by graphql-codegen.
 * Changes may cause incorrect behavior and will be lost when the code is regenerated.
 *
 * Run `npm run codegen` to regenerate.
 */

/** All built-in and custom scalars, mapped to their actual values */

/** Customers address */

/** Customers address metadata */

/** Enum allowed search results */
export var AddressMetadataAllowedSearchResults = /*#__PURE__*/function (AddressMetadataAllowedSearchResults) {
  AddressMetadataAllowedSearchResults["Area"] = "Area";
  AddressMetadataAllowedSearchResults["City"] = "City";
  AddressMetadataAllowedSearchResults["Country"] = "Country";
  AddressMetadataAllowedSearchResults["District"] = "District";
  AddressMetadataAllowedSearchResults["Locality"] = "Locality";
  AddressMetadataAllowedSearchResults["Market"] = "Market";
  AddressMetadataAllowedSearchResults["Province"] = "Province";
  AddressMetadataAllowedSearchResults["Region"] = "Region";
  AddressMetadataAllowedSearchResults["Street"] = "Street";
  AddressMetadataAllowedSearchResults["ZipCode"] = "ZipCode";
  return AddressMetadataAllowedSearchResults;
}({});

/** Delivery */

/** Delivery validation */

/** Operation */

/** Operation reasons */

/** Operations */

/** Search options */

/** Address type */

/** Address type validation */

/** Address field validation */

/** Enum address type */
export var AddressType = /*#__PURE__*/function (AddressType) {
  AddressType["Channel"] = "Channel";
  AddressType["Delivery"] = "Delivery";
  AddressType["Home"] = "Home";
  AddressType["Kyc"] = "Kyc";
  AddressType["Other"] = "Other";
  return AddressType;
}({});

/** Group of application resources */

/** Group of application resources */

/** Group of application resources */

/** Group of application resources */

/** Group of application resources */

/** Group of application resources */

/** Group of application resources */

/** Customers approvals */

export var ArticleType = /*#__PURE__*/function (ArticleType) {
  ArticleType["BeautyEdit"] = "BeautyEdit";
  ArticleType["RelatedToProduct"] = "RelatedToProduct";
  ArticleType["Undefined"] = "Undefined";
  return ArticleType;
}({});
/** Channel to identify how we should notify user */
export var BackInStockNotificationChannel = /*#__PURE__*/function (BackInStockNotificationChannel) {
  BackInStockNotificationChannel["Email"] = "Email";
  BackInStockNotificationChannel["Sms"] = "Sms";
  return BackInStockNotificationChannel;
}({});

/** Input to let user subscribe to when the product is back in stock */

/** Background types */
export var BackgroundType = /*#__PURE__*/function (BackgroundType) {
  BackgroundType["Color"] = "Color";
  BackgroundType["Image"] = "Image";
  BackgroundType["None"] = "None";
  BackgroundType["Video"] = "Video";
  return BackgroundType;
}({});

/** Bank account */

/** Component of a product bundle */

export var CatalogueOfferType = /*#__PURE__*/function (CatalogueOfferType) {
  CatalogueOfferType["Buy"] = "Buy";
  CatalogueOfferType["Choose"] = "Choose";
  CatalogueOfferType["ChooseAndChoose"] = "ChooseAndChoose";
  CatalogueOfferType["ChooseAndGet"] = "ChooseAndGet";
  CatalogueOfferType["Get"] = "Get";
  CatalogueOfferType["None"] = "None";
  return CatalogueOfferType;
}({});

/** Category type deifnition */

/** Category type deifnition */

export var ChannelType = /*#__PURE__*/function (ChannelType) {
  ChannelType["Mv7"] = "MV7";
  ChannelType["Website"] = "Website";
  return ChannelType;
}({});
export var ChatBotMode = /*#__PURE__*/function (ChatBotMode) {
  ChatBotMode["AlwaysEnabled"] = "AlwaysEnabled";
  ChatBotMode["Disabled"] = "Disabled";
  ChatBotMode["NonBusinessHoursOnly"] = "NonBusinessHoursOnly";
  return ChatBotMode;
}({});

/** Color type */
export var ColorType = /*#__PURE__*/function (ColorType) {
  ColorType["Brown"] = "Brown";
  ColorType["Green"] = "Green";
  ColorType["White"] = "White";
  return ColorType;
}({});

/** Concept of products */

/** Consultant settings */

/** Customer */

/** Customer */

/** Customer */

/** Enum customer category */
export var CustomerCategory = /*#__PURE__*/function (CustomerCategory) {
  CustomerCategory["Anonymous"] = "Anonymous";
  CustomerCategory["Consultant"] = "Consultant";
  CustomerCategory["Employee"] = "Employee";
  CustomerCategory["EndConsumer"] = "EndConsumer";
  CustomerCategory["EndCustomer"] = "EndCustomer";
  CustomerCategory["Invitation"] = "Invitation";
  CustomerCategory["Other"] = "Other";
  return CustomerCategory;
}({});

/** Customer type */

/** DigialCatalog type */

/** DigialCatalog type */

/** DigialCatalog promotions */

/** Describe customer document */

/** Editorial article carousel */

/** Editorial banner */

/** Color */

/** Editorial banner content */

/** Image */

/** Editorial banner layout enumeration */
export var EditorialBannerLayoutEnum = /*#__PURE__*/function (EditorialBannerLayoutEnum) {
  EditorialBannerLayoutEnum["FourMedia"] = "FourMedia";
  EditorialBannerLayoutEnum["Headline"] = "Headline";
  EditorialBannerLayoutEnum["OneMediaCenterBottomText"] = "OneMediaCenterBottomText";
  EditorialBannerLayoutEnum["OneMediaOverlayLeftText"] = "OneMediaOverlayLeftText";
  EditorialBannerLayoutEnum["OneMediaOverlayRightText"] = "OneMediaOverlayRightText";
  EditorialBannerLayoutEnum["OneMediaParagraphText"] = "OneMediaParagraphText";
  EditorialBannerLayoutEnum["ParagraphText"] = "ParagraphText";
  EditorialBannerLayoutEnum["Quote"] = "Quote";
  EditorialBannerLayoutEnum["ThreeMediaRightBottomText"] = "ThreeMediaRightBottomText";
  EditorialBannerLayoutEnum["TwoMedia"] = "TwoMedia";
  EditorialBannerLayoutEnum["TwoMediaRightTopText"] = "TwoMediaRightTopText";
  EditorialBannerLayoutEnum["Video"] = "Video";
  return EditorialBannerLayoutEnum;
}({});

/** Text wrapper */

/** Editorial banner title color enumeration */
export var EditorialBannerTitleColorEnum = /*#__PURE__*/function (EditorialBannerTitleColorEnum) {
  EditorialBannerTitleColorEnum["Black"] = "Black";
  EditorialBannerTitleColorEnum["DarkGrey"] = "DarkGrey";
  EditorialBannerTitleColorEnum["White"] = "White";
  return EditorialBannerTitleColorEnum;
}({});

/** Editorial channel type */
export var EditorialChannelType = /*#__PURE__*/function (EditorialChannelType) {
  EditorialChannelType["Mobile"] = "Mobile";
  EditorialChannelType["Web"] = "Web";
  return EditorialChannelType;
}({});

/** Editorial header */

/** Editorial Olapic */

/** Editorial page */

/** Editorial page components. */

/** Editorial product box carousel */

/** Customers email */

/** ErrorDialogNewsletterSubsciptionConfiguration */

/** External Campaing */

/** FooterNewsletterSubsciptionConfiguration */

/** Enum gender */
export var Gender = /*#__PURE__*/function (Gender) {
  Gender["Man"] = "Man";
  Gender["Other"] = "Other";
  Gender["Woman"] = "Woman";
  return Gender;
}({});

/** Language type */

/** Language configuration type */

/** Enum language type */
export var LanguageType = /*#__PURE__*/function (LanguageType) {
  LanguageType["Alternative"] = "Alternative";
  LanguageType["Default"] = "Default";
  return LanguageType;
}({});

/** Data associated with a link */

/** Makeup Try On */

/** Mobile App */

/** Link of the mobile app */

export var MobileAppType = /*#__PURE__*/function (MobileAppType) {
  MobileAppType["None"] = "None";
  MobileAppType["ToSell"] = "ToSell";
  MobileAppType["ToShop"] = "ToShop";
  return MobileAppType;
}({});

/** Type of mobile app */

/** Mobile apps */

/** Header of the mobile apps page */

/** Mutation root */

/** Mutation root */

/** Navigation Item */

/** Collection of navigation items */

/** Possible types of Navigation items */
export var NavigationLinkType = /*#__PURE__*/function (NavigationLinkType) {
  NavigationLinkType["AllCategory"] = "AllCategory";
  NavigationLinkType["Bottom"] = "Bottom";
  NavigationLinkType["BottomCopyright"] = "BottomCopyright";
  NavigationLinkType["BottomLinks"] = "BottomLinks";
  NavigationLinkType["Catalogue"] = "Catalogue";
  NavigationLinkType["Catalogues"] = "Catalogues";
  NavigationLinkType["Category"] = "Category";
  NavigationLinkType["DigitalCatalogueCurrent"] = "DigitalCatalogueCurrent";
  NavigationLinkType["DigitalCatalogueNext"] = "DigitalCatalogueNext";
  NavigationLinkType["FocusPage"] = "FocusPage";
  NavigationLinkType["FooterColumn"] = "FooterColumn";
  NavigationLinkType["FooterColumnItem"] = "FooterColumnItem";
  NavigationLinkType["IDontKnowYet"] = "IDontKnowYet";
  NavigationLinkType["Inspiration"] = "Inspiration";
  NavigationLinkType["JoinRewards"] = "JoinRewards";
  NavigationLinkType["KeyIngredients"] = "KeyIngredients";
  NavigationLinkType["MenuTiles"] = "MenuTiles";
  NavigationLinkType["New"] = "New";
  NavigationLinkType["None"] = "None";
  NavigationLinkType["OurApps"] = "OurApps";
  NavigationLinkType["OutletShop"] = "OutletShop";
  NavigationLinkType["PaymentMethod"] = "PaymentMethod";
  NavigationLinkType["PaymentMethods"] = "PaymentMethods";
  NavigationLinkType["PopularBrand"] = "PopularBrand";
  NavigationLinkType["PopularBrands"] = "PopularBrands";
  NavigationLinkType["PopularLookbook"] = "PopularLookbook";
  NavigationLinkType["PopularProducts"] = "PopularProducts";
  NavigationLinkType["Qrtr"] = "QRTR";
  NavigationLinkType["RewardsShop"] = "RewardsShop";
  NavigationLinkType["SampleShop"] = "SampleShop";
  NavigationLinkType["Segment"] = "Segment";
  NavigationLinkType["SubCategory"] = "SubCategory";
  NavigationLinkType["SupportCenter"] = "SupportCenter";
  NavigationLinkType["TopNavigation"] = "TopNavigation";
  NavigationLinkType["WhatsNewInCategory"] = "WhatsNewInCategory";
  return NavigationLinkType;
}({});

/** Navigationag type definition */

/** Possible types of navigations */
export var NavigationType = /*#__PURE__*/function (NavigationType) {
  NavigationType["AboutTiles"] = "AboutTiles";
  NavigationType["Footer"] = "Footer";
  NavigationType["InspirationTiles"] = "InspirationTiles";
  NavigationType["JoinTiles"] = "JoinTiles";
  NavigationType["ShopSection"] = "ShopSection";
  NavigationType["TopNavigation"] = "TopNavigation";
  return NavigationType;
}({});

/** Newsletter Subsciption Configuration Type */

export var NotificationBannerThemeType = /*#__PURE__*/function (NotificationBannerThemeType) {
  NotificationBannerThemeType["Black"] = "Black";
  NotificationBannerThemeType["Grey"] = "Grey";
  return NotificationBannerThemeType;
}({});

/** Olapic configuration */

/** Olapic type enumeration */
export var OlapicTypeEnum = /*#__PURE__*/function (OlapicTypeEnum) {
  OlapicTypeEnum["Category"] = "Category";
  OlapicTypeEnum["FrontPage"] = "FrontPage";
  OlapicTypeEnum["Gallery"] = "Gallery";
  OlapicTypeEnum["ProductDetails"] = "ProductDetails";
  return OlapicTypeEnum;
}({});

/** Personal beauty store details */

/** Personal beauty store details */

/** Personal beauty store profile */

/** Personal product list configuration */

/** Customers phone */

/** PopupNewsletterSubsciptionConfiguration */

/** Product expected Inbound */

/** Product Label Domain Type */
export var ProductLabelDomainType = /*#__PURE__*/function (ProductLabelDomainType) {
  ProductLabelDomainType["Deal"] = "Deal";
  ProductLabelDomainType["Ppa"] = "PPA";
  ProductLabelDomainType["Shopping"] = "Shopping";
  return ProductLabelDomainType;
}({});

/** Product list of specified product type, for example: Personal, Favorite ... */

/** Product list item */

export var ProductListType = /*#__PURE__*/function (ProductListType) {
  ProductListType["Favorite"] = "Favorite";
  ProductListType["Personal"] = "Personal";
  ProductListType["Private"] = "Private";
  ProductListType["Wishlist"] = "Wishlist";
  return ProductListType;
}({});

/** Product listing banner */

/** Enum ProductListingBannerVideoType */
export var ProductListingBannerVideoType = /*#__PURE__*/function (ProductListingBannerVideoType) {
  ProductListingBannerVideoType["Mp4"] = "Mp4";
  ProductListingBannerVideoType["None"] = "None";
  ProductListingBannerVideoType["Youku"] = "Youku";
  ProductListingBannerVideoType["Youtube"] = "Youtube";
  return ProductListingBannerVideoType;
}({});

/** Product Listing Page */

/** Content of the product listing page */

/** Product attached to banner */

/** Promo Banner for Product Listing Page */

/** Video attached to the banner */

/** Collection of related product codes */

/** Relation types */
export var ProductRelationEnum = /*#__PURE__*/function (ProductRelationEnum) {
  ProductRelationEnum["RecentlyViewed"] = "RecentlyViewed";
  ProductRelationEnum["Related"] = "Related";
  return ProductRelationEnum;
}({});
export var ProductType = /*#__PURE__*/function (ProductType) {
  ProductType["Bundle"] = "Bundle";
  ProductType["Composite"] = "Composite";
  ProductType["Fee"] = "Fee";
  ProductType["Product"] = "Product";
  ProductType["Sample"] = "Sample";
  return ProductType;
}({});

/** Query root */

/** Query root */

/** Query root */

/** Query root */

/** Query root */

/** Query root */

/** Query root */

/** Query root */

/** Query root */

/** Query root */

/** Query root */

/** Query root */

/** ResponseMessageNewsletterSubsciptionConfiguration */

/** ResponseMessageNewsletterSubsciptionsType */
export var ResponseMessageNewsletterSubsciptionsType = /*#__PURE__*/function (ResponseMessageNewsletterSubsciptionsType) {
  ResponseMessageNewsletterSubsciptionsType["Cleaned"] = "Cleaned";
  ResponseMessageNewsletterSubsciptionsType["New"] = "New";
  ResponseMessageNewsletterSubsciptionsType["Pending"] = "Pending";
  ResponseMessageNewsletterSubsciptionsType["Subscribed"] = "Subscribed";
  ResponseMessageNewsletterSubsciptionsType["Unsubscribed"] = "Unsubscribed";
  return ResponseMessageNewsletterSubsciptionsType;
}({});
export var SettingsClientType = /*#__PURE__*/function (SettingsClientType) {
  SettingsClientType["OnlineReportingGrid"] = "OnlineReportingGrid";
  SettingsClientType["WellnessClub"] = "WellnessClub";
  return SettingsClientType;
}({});
export var SettingsFormatType = /*#__PURE__*/function (SettingsFormatType) {
  SettingsFormatType["Json"] = "Json";
  SettingsFormatType["String"] = "String";
  SettingsFormatType["Xml"] = "Xml";
  return SettingsFormatType;
}({});

/** Live video show type */
export var ShowType = /*#__PURE__*/function (ShowType) {
  ShowType["Ended"] = "Ended";
  ShowType["Live"] = "Live";
  ShowType["Scheduled"] = "Scheduled";
  return ShowType;
}({});

/** Sized image wariant */

/** Social contact */

/** Types of social contact */
export var SocialContactType = /*#__PURE__*/function (SocialContactType) {
  SocialContactType["Email"] = "Email";
  SocialContactType["Facebook"] = "Facebook";
  SocialContactType["PhoneNumber"] = "PhoneNumber";
  SocialContactType["VKontakte"] = "VKontakte";
  SocialContactType["WeChat"] = "WeChat";
  SocialContactType["WhatsUpNumber"] = "WhatsUpNumber";
  return SocialContactType;
}({});

/** SocialMediaLinks type */

/** Types of social media */
export var SocialMediaType = /*#__PURE__*/function (SocialMediaType) {
  SocialMediaType["Facebook"] = "Facebook";
  SocialMediaType["Instagram"] = "Instagram";
  SocialMediaType["Line"] = "Line";
  SocialMediaType["Odnoklassniki"] = "Odnoklassniki";
  SocialMediaType["Pinterest"] = "Pinterest";
  SocialMediaType["Qq"] = "QQ";
  SocialMediaType["Twitter"] = "Twitter";
  SocialMediaType["VKontakte"] = "VKontakte";
  SocialMediaType["Weibo"] = "Weibo";
  SocialMediaType["YouTube"] = "YouTube";
  SocialMediaType["Youku"] = "Youku";
  return SocialMediaType;
}({});

/** Sponsor */

/** Sponsor type */
export var SponsorType = /*#__PURE__*/function (SponsorType) {
  SponsorType["DirectSponsor"] = "DirectSponsor";
  return SponsorType;
}({});

/** SubmitDialogNewsletterSubsciptionConfiguration */

/** SubscribedDialogNewsletterSubsciptionConfiguration */

/** Enum telephone type */
export var TelephoneType = /*#__PURE__*/function (TelephoneType) {
  TelephoneType["Business"] = "Business";
  TelephoneType["Fax"] = "Fax";
  TelephoneType["Home"] = "Home";
  TelephoneType["Mobile"] = "Mobile";
  return TelephoneType;
}({});

/** Group of VideoShopping resources */

/** Video shopping configuration */

/** Video Shopping Localization */

/** live video show */

export var VideoType = /*#__PURE__*/function (VideoType) {
  VideoType["Mp4"] = "Mp4";
  VideoType["Youku"] = "Youku";
  VideoType["Youtube"] = "Youtube";
  return VideoType;
}({});
/** Possible types of visitor segment */
export var VisitorSegment = /*#__PURE__*/function (VisitorSegment) {
  VisitorSegment["Anonymous"] = "Anonymous";
  VisitorSegment["Consultant"] = "Consultant";
  VisitorSegment["DirectorAndAbove"] = "DirectorAndAbove";
  VisitorSegment["EndCustomer"] = "EndCustomer";
  VisitorSegment["Manager"] = "Manager";
  VisitorSegment["Member"] = "Member";
  VisitorSegment["NewConsultant"] = "NewConsultant";
  VisitorSegment["NotDefined"] = "NotDefined";
  VisitorSegment["Spo"] = "Spo";
  return VisitorSegment;
}({});

/** Group of Wellness Club resources */

/** Wellness Club banners */

/** Wellness Club configuration */

/** Wellness Club localization */